import {
  accountLogin, forgetPassword,
  headingLogin,
  modifyPassword,
  needCaptchaAuth,
  phoneLogin, resetPassword, switchOrg, unLock, uniLogin,
} from '@/services/account/Login';
import { getloginPage } from '@/services/account/LoginandIndexConfig';
import { getByUserUuid } from '@/services/internal/facility/config/UserConfig';
import { reloadAuthorized } from '@/utils/Authorized';
import { cacheLogin, clearLogin, clearPageFilter, loginKey, loginOrg } from '@/utils/LoginContext';
import { getPageQuery } from '@/utils/utils';
import { routerRedux } from 'dva/router';
import { stringify } from 'qs';
export default {
  namespace: 'login',
  state: {
    status: undefined,
  },
  effects: {
    *accountLogin({ payload, callback }, { call, put }) {
      yield put({
        type: 'changeSubmitting',
        payload: true,
      });
      const response = yield call(accountLogin, payload);
      if (response && response.success) {
        sessionStorage.clear();
        cacheLogin(response.data);
        let viewPageLine = 50;
        let searchPageLine = 50;
        // let editPageLine = 20;
        let expandSearchConditions = false;
        let autoDataLoad = true;
        if (response.data.orgType === 'DC') { //查询用户配置
          let params = {
            userUuid: response.data.userUuid,
            dcUuid: response.data.orgUuid
          }
          const userConfig = yield call(getByUserUuid, params);
          if (userConfig && userConfig.success) {
            viewPageLine = userConfig.data ? userConfig.data.viewPageLine : 50;
            searchPageLine = userConfig.data ? userConfig.data.searchPageLine : 50;
            // editPageLine = userConfig.data ? userConfig.data.editPageLine : 20;
            expandSearchConditions = userConfig.data ? userConfig.data.expandSearchConditions : expandSearchConditions;
            autoDataLoad = userConfig.data ? userConfig.data.autoDataLoad : autoDataLoad;
          }
        }
        window.sessionStorage.setItem('viewPageLine', viewPageLine);
        window.sessionStorage.setItem('searchPageLine', searchPageLine);
        // window.sessionStorage.setItem('editPageLine', editPageLine);
        window.sessionStorage.setItem('expandSearchConditions', expandSearchConditions);
        window.sessionStorage.setItem('autoDataLoad', autoDataLoad);

        reloadAuthorized();
        const urlParams = new URL(window.location.href);
        const params = getPageQuery();
        let { redirect } = params;
        if (redirect) {
          const redirectUrlParams = new URL(redirect);
          if (redirectUrlParams.origin === urlParams.origin) {
            redirect = redirect.substr(urlParams.origin.length);
            if (redirect.match(/^\/.*#/)) {
              redirect = redirect.substr(redirect.indexOf('#') + 1);
            }
          } else {
            window.location.href = redirect;
            yield put({
              type: 'changeSubmitting',
              payload: false,
            });
            return;
          }
        }
        yield put(routerRedux.replace(redirect || '/'));
      } else {
        yield put({
          type: 'changeLoginStatus',
          payload: {
            status: 'error',
            message: response.message,
          },
        });
      }
      yield put({
        type: 'changeSubmitting',
        payload: false,
      });
      if (callback) callback(response);
    },
    *headingLogin({ payload, callback }, { call, put }) {
      yield put({
        type: 'changeSubmitting',
        payload: true,
      });
      const response = yield call(headingLogin, payload);
      if (response && response.success) {
        sessionStorage.clear();
        cacheLogin(response.data);
        let viewPageLine = 50;
        let searchPageLine = 50;
        // let editPageLine = 20;
        let expandSearchConditions = false;
        let autoDataLoad = true;
        if (response.data.orgType === 'DC') { //查询用户配置
          let params = {
            userUuid: response.data.userUuid,
            dcUuid: response.data.orgUuid
          }
          const userConfig = yield call(getByUserUuid, params);
          if (userConfig && userConfig.success) {
            viewPageLine = userConfig.data ? userConfig.data.viewPageLine : 50;
            searchPageLine = userConfig.data ? userConfig.data.searchPageLine : 50;
            // editPageLine = userConfig.data ? userConfig.data.editPageLine : 20;
            expandSearchConditions = userConfig.data ? userConfig.data.expandSearchConditions : expandSearchConditions;
            autoDataLoad = userConfig.data ? userConfig.data.autoDataLoad : autoDataLoad;
          }
        }
        window.sessionStorage.setItem('viewPageLine', viewPageLine);
        window.sessionStorage.setItem('searchPageLine', searchPageLine);
        // window.sessionStorage.setItem('editPageLine', editPageLine);
        window.sessionStorage.setItem('expandSearchConditions', expandSearchConditions);
        window.sessionStorage.setItem('autoDataLoad', autoDataLoad);

        reloadAuthorized();
        const urlParams = new URL(window.location.href);
        const params = getPageQuery();
        let { redirect } = params;
        if (redirect) {
          const redirectUrlParams = new URL(redirect);
          if (redirectUrlParams.origin === urlParams.origin) {
            redirect = redirect.substr(urlParams.origin.length);
            if (redirect.match(/^\/.*#/)) {
              redirect = redirect.substr(redirect.indexOf('#') + 1);
            }
          } else {
            window.location.href = redirect;
            yield put({
              type: 'changeSubmitting',
              payload: false,
            });
            return;
          }
        }
        yield put(routerRedux.replace(redirect || '/'));
      } else {
        yield put({
          type: 'changeLoginStatus',
          payload: {
            status: 'error',
            message: response.message,
          },
        });
      }
      yield put({
        type: 'changeSubmitting',
        payload: false,
      });
      if (callback) callback(response);
    },
    *phoneLogin({ payload, callback }, { call, put }) {
      yield put({
        type: 'changeSubmitting',
        payload: true,
      });
      const response = yield call(phoneLogin, payload);
      if (response && response.success) {
        sessionStorage.clear();
        cacheLogin(response.data);
        let viewPageLine = 50;
        let searchPageLine = 50;
        // let editPageLine = 20;
        let expandSearchConditions = false;
        let autoDataLoad = true;
        if (response.data.orgType === 'DC') { //查询用户配置
          let params = {
            userUuid: response.data.userUuid,
            dcUuid: response.data.orgUuid
          }
          const userConfig = yield call(getByUserUuid, params);
          if (userConfig && userConfig.success) {
            viewPageLine = userConfig.data ? userConfig.data.viewPageLine : 50;
            searchPageLine = userConfig.data ? userConfig.data.searchPageLine : 50;
            // editPageLine = userConfig.data ? userConfig.data.editPageLine : 20;
            expandSearchConditions = userConfig.data ? userConfig.data.expandSearchConditions : expandSearchConditions;
            autoDataLoad = userConfig.data ? userConfig.data.autoDataLoad : autoDataLoad;
          }
        }
        window.sessionStorage.setItem('viewPageLine', viewPageLine);
        window.sessionStorage.setItem('searchPageLine', searchPageLine);
        // window.sessionStorage.setItem('editPageLine', editPageLine);
        window.sessionStorage.setItem('expandSearchConditions', expandSearchConditions);
        window.sessionStorage.setItem('autoDataLoad', autoDataLoad);

        reloadAuthorized();
        const urlParams = new URL(window.location.href);
        const params = getPageQuery();
        let { redirect } = params;
        if (redirect) {
          const redirectUrlParams = new URL(redirect);
          if (redirectUrlParams.origin === urlParams.origin) {
            redirect = redirect.substr(urlParams.origin.length);
            if (redirect.match(/^\/.*#/)) {
              redirect = redirect.substr(redirect.indexOf('#') + 1);
            }
          } else {
            window.location.href = redirect;
            yield put({
              type: 'changeSubmitting',
              payload: false,
            });
            return;
          }
        }
        yield put(routerRedux.replace(redirect || '/'));
      } else {
        yield put({
          type: 'changeLoginStatus',
          payload: {
            status: 'error',
            message: response.message,
          },
        });
      }
      yield put({
        type: 'changeSubmitting',
        payload: false,
      });
    },

    *logout(_, { put }) {
      yield put({
        type: 'changeLoginStatus',
        payload: {
          status: false,
          currentAuthority: 'guest',
        },
      });
      let orgType = loginOrg().type;
      clearLogin();
      reloadAuthorized();
      if (window.g_configs.AUTH_METHOD === 'wms') {
        yield put(
          routerRedux.push({
            pathname: '/user/login',
          })
        );
      } else {
        if (orgType === 'HEADING') {
          yield put(
            routerRedux.push({
              pathname: '/heading/login',
            })
          );
        } else {
          window.location.href = window.sessionStorage.getItem('uniSiderBar') ? JSON.parse(window.sessionStorage.getItem('uniSiderBar')).uniHomeUrl : '#'
        }
      }
    },

    *check({ payload }, { call, put }) {
      yield put({
        type: 'changeSubmitting',
        payload: true,
      });
      if (!loginKey()) {
        yield put(
          routerRedux.push({
            pathname: '/user/login',
            search: stringify({
              redirect: window.location.href,
            }),
          })
        );
      }
      yield put({
        type: 'changeSubmitting',
        payload: false,
      });
    },

    *modifyPassword({ payload, callback }, { call, put }) {
      yield put({
        type: 'changeSubmitting',
        payload: true,
      });
      const response = yield call(modifyPassword, payload);
      yield put({
        type: 'changeSubmitting',
        payload: false,
      });
      if (callback) { callback(response); }
    },

    *switchOrg({ payload, callback }, { call, put }) {
      yield put({
        type: 'changeSubmitting',
        payload: true,
      });
      const response = yield call(switchOrg, payload);
      yield put({
        type: 'changeSubmitting',
        payload: false,
      });
      // sessionStorage.clear();
      if (response && response.success) {
        // cacheLogin(response.data);
        sessionStorage.clear();
        clearPageFilter();
        cacheLogin(response.data);
        let viewPageLine = 50;
        let searchPageLine = 50;
        // let editPageLine = 20;
        let expandSearchConditions = false;
        let autoDataLoad = true;
        if (response.data.orgType === 'DC') { //查询用户配置
          let params = {
            userUuid: response.data.userUuid,
            dcUuid: response.data.orgUuid
          }
          const userConfig = yield call(getByUserUuid, params);
          if (userConfig && userConfig.success) {
            viewPageLine = userConfig.data ? userConfig.data.viewPageLine : 50;
            searchPageLine = userConfig.data ? userConfig.data.searchPageLine : 50;
            // editPageLine = userConfig.data ? userConfig.data.editPageLine : 20;
            expandSearchConditions = userConfig.data ? userConfig.data.expandSearchConditions : expandSearchConditions;
            autoDataLoad = userConfig.data ? userConfig.data.autoDataLoad : autoDataLoad;
          }
        }
        window.sessionStorage.setItem('viewPageLine', viewPageLine);
        window.sessionStorage.setItem('searchPageLine', searchPageLine);
        // window.sessionStorage.setItem('editPageLine', editPageLine);
        window.sessionStorage.setItem('expandSearchConditions', expandSearchConditions);
        window.sessionStorage.setItem('autoDataLoad', autoDataLoad);

        reloadAuthorized();
        yield put(routerRedux.push('/'));
      }
      if (callback) { callback(response); }
    },

    *forgetPassword({ payload, callback }, { call, put }) {
      yield put({
        type: 'changeSubmitting',
        payload: true,
      });
      const response = yield call(forgetPassword, payload);
      yield put({
        type: 'changeSubmitting',
        payload: false,
      });
      if (callback) { callback(response); }
    },

    *resetPassword({ payload, callback }, { call, put }) {
      const response = yield call(resetPassword, payload);
      if (callback) { callback(response); }
    },

    *unLock({ payload, callback }, { call, put }) {
      const response = yield call(unLock, payload);
      if (callback) { callback(response); }
    },
    *uniLogin({ payload, callback }, { call, put }) {
      const response = yield call(uniLogin, payload);
      if (response && response.success) {
        sessionStorage.clear();
        cacheLogin(response.data);
        let viewPageLine = 50;
        let searchPageLine = 50;
        // let editPageLine = 20;
        let expandSearchConditions = false;
        let autoDataLoad = true;
        if (response.data.orgType === 'DC') { //查询用户配置
          let params = {
            userUuid: response.data.userUuid,
            dcUuid: response.data.orgUuid
          }
          const userConfig = yield call(getByUserUuid, params);
          if (userConfig && userConfig.success) {
            viewPageLine = userConfig.data ? userConfig.data.viewPageLine : 50;
            searchPageLine = userConfig.data ? userConfig.data.searchPageLine : 50;
            // editPageLine = userConfig.data ? userConfig.data.editPageLine : 20;
            expandSearchConditions = userConfig.data ? userConfig.data.expandSearchConditions : expandSearchConditions;
            autoDataLoad = userConfig.data ? userConfig.data.autoDataLoad : autoDataLoad;
          }
        }
        window.sessionStorage.setItem('viewPageLine', viewPageLine);
        window.sessionStorage.setItem('searchPageLine', searchPageLine);
        window.sessionStorage.setItem('expandSearchConditions', expandSearchConditions);
        window.sessionStorage.setItem('autoDataLoad', autoDataLoad);
        window.sessionStorage.setItem('uniSiderBar', JSON.stringify({ uniBffUrl: response.data.uniBffUrl, uniHomeUrl: response.data.uniHomeUrl }));
        reloadAuthorized();
        const urlParams = new URL(window.location.href);
        const params = getPageQuery();
        let { redirect } = params;
        if (redirect) {
          const redirectUrlParams = new URL(redirect);
          if (redirectUrlParams.origin === urlParams.origin) {
            redirect = redirect.substr(urlParams.origin.length);
            if (redirect.match(/^\/.*#/)) {
              redirect = redirect.substr(redirect.indexOf('#') + 1);
            }
          } else {
            window.location.href = redirect;
            yield put({
              type: 'changeSubmitting',
              payload: false,
            });
            return;
          }
        }
        yield put(routerRedux.replace(redirect || '/'));
      } else {
        yield put({
          type: 'changeLoginStatus',
          payload: {
            status: 'error',
            message: response.message,
          },
        });
      }
      if (callback) { callback(response); }
    },
    *needCaptchaAuth({ payload, callback }, { call, put }) {
      const response = yield call(needCaptchaAuth, payload);
      if (callback) { callback(response); }
    },
    *getloginPage({ payload, callback }, { call, put }) {
      const response = yield call(getloginPage, payload);
      if (callback) callback(response);
    }
  },

  reducers: {
    changeLoginStatus(state, { payload }) {
      return {
        ...state,
        result: payload.result,
        message: payload.message,
        status: payload.status,
      };
    },
    changeSubmitting(state, { payload }) {
      return {
        ...state,
        submitting: payload,
      };
    },
  },
};
